import api from './api'

export interface Address {
  line_1: string
  line_2?: string
  line_3?: string
  post_town: string
  postcode: string
  county?: string
  country: string
  formatted: string
  udprn?: string
}

export interface AutocompleteSuggestion {
  suggestion: string
  url: string
  udprn: string
}

export const idealPostcodesService = {
  /**
   * Lookup addresses for a UK postcode
   */
  async lookupPostcode(postcode: string): Promise<{ success: boolean; message: string; addresses: Address[] | null }> {
    try {
      const response = await api.post('/addresses/lookup', { postcode })
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.detail || 'Failed to lookup postcode',
        addresses: null
      }
    }
  },

  /**
   * Autocomplete address as user types
   */
  async autocompleteAddress(query: string, limit = 10): Promise<{ success: boolean; message: string; suggestions: AutocompleteSuggestion[] | null }> {
    try {
      const response = await api.post('/addresses/autocomplete', { query, limit })
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.detail || 'Failed to get address suggestions',
        suggestions: null
      }
    }
  },

  /**
   * Get full address details by UDPRN
   */
  async getAddressByUdprn(udprn: string): Promise<Address | null> {
    try {
      const response = await api.get(`/addresses/address/${udprn}`)
      return response.data
    } catch (error) {
      return null
    }
  },

  /**
   * Validate if a postcode exists
   */
  async validatePostcode(postcode: string): Promise<{ valid: boolean; message: string; postcode: string }> {
    try {
      const response = await api.get(`/addresses/validate/${postcode}`)
      return response.data
    } catch (error: any) {
      return {
        valid: false,
        message: error.response?.data?.detail || 'Failed to validate postcode',
        postcode
      }
    }
  }
}
